import React from 'react';
import { Table } from 'semantic-ui-react';
import RowAddButton from '../buttons/RowAddButton';

const RowAddColumn = ({
  entity,
  onClick,
  disabled,
  colWidth,
  text,
}) => (
  <Table.HeaderCell singleLine textAlign="right" width={colWidth} className="z-5">
    <RowAddButton
      entity={entity}
      onClick={onClick}
      dataPosition="bottom right"
      disabled={disabled}
      text={text}
    />
  </Table.HeaderCell>
);

export default RowAddColumn;
